"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_control__panel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ddaec3dd-bc7a-4deb-aa45-43ff9918c481",
    x1: 98.79,
    y1: 91.65,
    x2: 136.19,
    y2: 136.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7014f260-17dd-4ee3-854e-6edf495162d7",
    x1: 132.59,
    y1: 74.32,
    x2: 154.43,
    y2: 92.65,
    xlinkHref: "#ddaec3dd-bc7a-4deb-aa45-43ff9918c481"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "63323ff5-1762-47e3-84a8-2643f0db8db3",
    x1: 63.83,
    y1: 115.81,
    x2: 94.83,
    y2: 154.56,
    xlinkHref: "#ddaec3dd-bc7a-4deb-aa45-43ff9918c481"
  })), /*#__PURE__*/React.createElement("title", null, "control-panel-hi"), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "f9cc3e8f-99a2-4ac0-b519-1cecd48b0b7d",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.02,
    y: 24,
    width: 144,
    height: 144,
    rx: 15.93,
    ry: 15.93,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.08,166H40A16,16,0,0,1,24,150.07v2A16,16,0,0,0,40,168H152.08A16,16,0,0,0,168,152.07v-2A16,16,0,0,1,152.08,166Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "8a3bdd30-08ed-4b58-a014-0b8ba425f545",
    "data-name": "7f66255b-2a61-4e73-996c-2c1a50525e8c",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "5c35a4f4-98a7-4a83-b458-b11d38547487",
    "data-name": "5c4f2b92-07f6-4ff9-b67e-830645899972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6ab1eca2-039a-4c4d-af38-b617610227fe",
    "data-name": "705e5bf6-d581-4ddc-b208-ed2f49f90bfe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ab7dfeec-bf5d-4ee3-b3e3-6679093e2230",
    "data-name": "70e05428-b58c-4a66-9253-0c886552d4ae"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0d1d215e-50de-48d1-8464-faf06a70309f",
    "data-name": "650d53b2-faca-4d71-99fb-e1950504cb64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "84fe6ae1-4847-418d-a772-c5a329396eed",
    "data-name": "f12a75af-17f2-4aac-b0f6-1e8d8f0d38d3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d4b6bdb2-df50-4a89-9a4f-6316dd0084b4",
    "data-name": "3d8f5649-85e4-4924-9e85-5e682eaebb78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b8048d18-7cde-4179-ae9d-687dde063580",
    "data-name": "a84d5521-e1f3-4e8f-8c74-b20bbbba497a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,47.34v96c0,2.87-1.79,4.66-4,4.66h0c-2.21,0-4-1.79-4-4.66v-96c0-1.55,1.8-3.34,4-3.34h0C98.23,44,100,45.79,100,47.34Z",
    transform: "translate(0 0)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "d31fe58a-d1df-4e16-887d-7e55e8110797",
    "data-name": "7f66255b-2a61-4e73-996c-2c1a50525e8c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "240b5036-dcd8-4730-b86e-3ef19d5e91b3",
    "data-name": "5c4f2b92-07f6-4ff9-b67e-830645899972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5e8a9f1a-2d81-412b-afdd-655ba9a9896d",
    "data-name": "705e5bf6-d581-4ddc-b208-ed2f49f90bfe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "058ace8b-5d66-40c9-b884-a8d58dd0919e",
    "data-name": "70e05428-b58c-4a66-9253-0c886552d4ae"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a1bc4990-d4bc-49ad-be27-4b174c016fc3",
    "data-name": "650d53b2-faca-4d71-99fb-e1950504cb64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "20f59125-735d-495d-a93d-d8e815821f3e",
    "data-name": "f12a75af-17f2-4aac-b0f6-1e8d8f0d38d3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a149e620-530b-4347-9e30-a0618ba7d99b",
    "data-name": "3d8f5649-85e4-4924-9e85-5e682eaebb78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cde3bfa4-1d5d-4d24-bf53-30e9a860818e",
    "data-name": "a84d5521-e1f3-4e8f-8c74-b20bbbba497a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,49.89v93.45c0,2.87-1.79,4.66-4,4.66h0c-2.21,0-4-1.79-4-4.66V49.89c0-1.54,1.8-3.33,4-3.33h0C98.23,46.56,100,48.35,100,49.89Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }))))))))), /*#__PURE__*/React.createElement("polygon", {
    points: "81.05 103.02 129.67 151.64 166.25 140.15 111.05 84.96 81.05 103.02",
    opacity: 0.2,
    fill: "url(#ddaec3dd-bc7a-4deb-aa45-43ff9918c481)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 84,
    width: 32,
    height: 20,
    rx: 3.44,
    ry: 3.44,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.56,102H83.44A3.44,3.44,0,0,1,80,98.56v2A3.44,3.44,0,0,0,83.44,104h25.12a3.44,3.44,0,0,0,3.44-3.44v-2A3.44,3.44,0,0,1,108.56,102Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "7c5297a7-2847-479a-8521-9323aee928aa",
    "data-name": "7f66255b-2a61-4e73-996c-2c1a50525e8c",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "2e0c3138-824b-45dd-9210-9fe19fccfb34",
    "data-name": "5c4f2b92-07f6-4ff9-b67e-830645899972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "62155e6a-6a80-4885-b68e-4b379fa7f5d6",
    "data-name": "705e5bf6-d581-4ddc-b208-ed2f49f90bfe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5e9ab56b-9c45-4eb6-80aa-e598c5fdd22e",
    "data-name": "70e05428-b58c-4a66-9253-0c886552d4ae"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2607b9ed-41ec-4d64-bf3c-e9d5e5899bb0",
    "data-name": "650d53b2-faca-4d71-99fb-e1950504cb64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1d179db9-7491-4617-97e6-c5f024e544fb",
    "data-name": "f12a75af-17f2-4aac-b0f6-1e8d8f0d38d3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c7f10f72-f852-4ab7-b716-dcceb486a8fa",
    "data-name": "3d8f5649-85e4-4924-9e85-5e682eaebb78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5fdbbc8d-65e3-4ebf-9911-b89e2756ad35",
    "data-name": "a84d5521-e1f3-4e8f-8c74-b20bbbba497a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136,47.34v96c0,2.87-1.79,4.66-4,4.66h0c-2.21,0-4-1.79-4-4.66v-96c0-1.55,1.8-3.34,4-3.34h0C134.23,44,136,45.79,136,47.34Z",
    transform: "translate(0 0)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "0f557f2f-95bc-42fa-9e79-2549d6a0c927",
    "data-name": "7f66255b-2a61-4e73-996c-2c1a50525e8c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e649e480-c241-4cb3-ad83-4f165294e972",
    "data-name": "5c4f2b92-07f6-4ff9-b67e-830645899972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1ea37ac0-ad48-4e35-a08f-ede2039d8a40",
    "data-name": "705e5bf6-d581-4ddc-b208-ed2f49f90bfe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5d85eaf9-431e-44dc-8b92-ff71abf269da",
    "data-name": "70e05428-b58c-4a66-9253-0c886552d4ae"
  }, /*#__PURE__*/React.createElement("g", {
    id: "accfbb7c-1fc1-4dfb-bcc5-e95e2b3dc610",
    "data-name": "650d53b2-faca-4d71-99fb-e1950504cb64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6432f8b0-6375-4bd5-a5dd-89eb8db57d7b",
    "data-name": "f12a75af-17f2-4aac-b0f6-1e8d8f0d38d3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e7fa262c-0757-4fc9-bae0-7574676b8c97",
    "data-name": "3d8f5649-85e4-4924-9e85-5e682eaebb78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "739f38dc-f01e-4565-bbd7-a175d985047a",
    "data-name": "a84d5521-e1f3-4e8f-8c74-b20bbbba497a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136,49.89v93.45c0,2.87-1.79,4.66-4,4.66h0c-2.21,0-4-1.79-4-4.66V49.89c0-1.54,1.8-3.33,4-3.33h0C134.23,46.56,136,48.35,136,49.89Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }))))))))), /*#__PURE__*/React.createElement("polygon", {
    points: "117.05 78.99 165.67 127.61 165.51 79.39 147.05 60.93 117.05 78.99",
    opacity: 0.2,
    fill: "url(#7014f260-17dd-4ee3-854e-6edf495162d7)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 59.97,
    width: 32,
    height: 20,
    rx: 3.44,
    ry: 3.44,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.56,78H119.44A3.44,3.44,0,0,1,116,74.53v2A3.45,3.45,0,0,0,119.44,80h25.12A3.45,3.45,0,0,0,148,76.53v-2A3.44,3.44,0,0,1,144.56,78Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "0958fc21-f6b9-4a1a-87c7-e92748555eda",
    "data-name": "7f66255b-2a61-4e73-996c-2c1a50525e8c",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "6b4c01a4-881d-4a4a-bcae-2925be7242a9",
    "data-name": "5c4f2b92-07f6-4ff9-b67e-830645899972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ded5659f-9d81-4582-93be-880d3102acd0",
    "data-name": "705e5bf6-d581-4ddc-b208-ed2f49f90bfe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3bdc2186-108b-43d1-b84f-27199fb04a4d",
    "data-name": "70e05428-b58c-4a66-9253-0c886552d4ae"
  }, /*#__PURE__*/React.createElement("g", {
    id: "600a094c-1373-4c8a-af17-bae1a810be7d",
    "data-name": "650d53b2-faca-4d71-99fb-e1950504cb64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f0628fb3-e47b-4d74-8ee0-f4e7b444bb30",
    "data-name": "f12a75af-17f2-4aac-b0f6-1e8d8f0d38d3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e2523718-0a9f-4f67-bd3c-4136e71ba182",
    "data-name": "3d8f5649-85e4-4924-9e85-5e682eaebb78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1a579458-ceda-4f16-8129-ec5bb5d3b4f4",
    "data-name": "a84d5521-e1f3-4e8f-8c74-b20bbbba497a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64,47.34v96c0,2.87-1.79,4.66-4,4.66h0c-2.21,0-4-1.79-4-4.66v-96c0-1.55,1.8-3.34,4-3.34h0C62.23,44,64,45.79,64,47.34Z",
    transform: "translate(0 0)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "050a6ebc-7000-477e-bc56-bb4f077c9e1b",
    "data-name": "7f66255b-2a61-4e73-996c-2c1a50525e8c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "deca9fb8-6ddf-4fbd-a6ea-94f3e5efe1be",
    "data-name": "5c4f2b92-07f6-4ff9-b67e-830645899972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ded6bd3e-8b2e-4aaa-baf0-eb3cac6ba895",
    "data-name": "705e5bf6-d581-4ddc-b208-ed2f49f90bfe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3ff5ce4c-2b83-4a86-a4d1-ecf00c29bc37",
    "data-name": "70e05428-b58c-4a66-9253-0c886552d4ae"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d0aa91af-217d-4562-a3c5-7f98b3f5755d",
    "data-name": "650d53b2-faca-4d71-99fb-e1950504cb64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fea75621-e17f-4f4b-8f67-50080eee81c6",
    "data-name": "f12a75af-17f2-4aac-b0f6-1e8d8f0d38d3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "65a03ac0-e935-4053-b9e9-6da8059697be",
    "data-name": "3d8f5649-85e4-4924-9e85-5e682eaebb78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8a6eb3fa-e897-49d8-9bbf-639bc547a9c1",
    "data-name": "a84d5521-e1f3-4e8f-8c74-b20bbbba497a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64,49.89v93.45c0,2.87-1.79,4.66-4,4.66h0c-2.21,0-4-1.79-4-4.66V49.89c0-1.54,1.8-3.33,4-3.33h0C62.23,46.56,64,48.35,64,49.89Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }))))))))), /*#__PURE__*/React.createElement("polygon", {
    points: "45.05 127.02 83.73 165.71 130.25 164.16 75.05 108.96 45.05 127.02",
    opacity: 0.2,
    fill: "url(#63323ff5-1762-47e3-84a8-2643f0db8db3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 108,
    width: 32,
    height: 20,
    rx: 3.44,
    ry: 3.44,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.56,126H47.44A3.44,3.44,0,0,1,44,122.56v2A3.44,3.44,0,0,0,47.44,128H72.56A3.44,3.44,0,0,0,76,124.56v-2A3.44,3.44,0,0,1,72.56,126Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  })))));
}

var _default = ic_control__panel;
exports.default = _default;